import { lazy, Suspense } from "react";
import Layout from "@/components/layout/Layout";
import HeroSection from "@/components/home/HeroSection";

const VisualExampleSection = lazy(() => import("@/components/home/VisualExampleSection"));
const WhoThisIsForSection = lazy(() => import("@/components/home/WhoThisIsForSection"));
const WhatYouGetSection = lazy(() => import("@/components/home/WhatYouGetSection"));
const HowItWorksSection = lazy(() => import("@/components/home/HowItWorksSection"));
const WhyNativePlantsSection = lazy(() => import("@/components/home/WhyNativePlantsSection"));
const PricingPreviewSection = lazy(() => import("@/components/home/PricingPreviewSection"));
const TrustExpectationsSection = lazy(() => import("@/components/home/TrustExpectationsSection"));
const FinalCTASection = lazy(() => import("@/components/home/FinalCTASection"));
const SEOFAQSection = lazy(() => import("@/components/home/SEOFAQSection"));

const SectionFallback = () => <div className="min-h-[120px]" />;

const Home = () => {
  return (
    <Layout>
      <HeroSection />
      <Suspense fallback={<SectionFallback />}>
        <VisualExampleSection />
        <WhoThisIsForSection />
        <WhatYouGetSection />
        <HowItWorksSection />
        <WhyNativePlantsSection />
        <PricingPreviewSection />
        <TrustExpectationsSection />
        <FinalCTASection />
        <SEOFAQSection />
      </Suspense>
    </Layout>
  );
};

export default Home;
